import apiClient from './client';
import { buildQueryString } from '../../lib/wallet/utils';

// ── Dashboard ──────────────────────────────────────────────────────
export const getDashboardStats = () =>
    apiClient.get('/admin/dashboard').then((r) => r.data);

// ── API Keys ───────────────────────────────────────────────────────
export const getApiKeys = (params = {}) =>
    apiClient.get(`/admin/api-keys${buildQueryString(params)}`).then((r) => r.data);

export const createApiKey = (data) =>
    apiClient.post('/admin/api-keys', data).then((r) => r.data);

export const toggleApiKey = (apiKeyId, data) =>
    apiClient.patch(`/admin/api-keys/${apiKeyId}`, data).then((r) => r.data);

// ── Users ──────────────────────────────────────────────────────────
export const getUsers = (params = {}) =>
    apiClient.get(`/admin/users${buildQueryString(params)}`).then((r) => r.data);

export const getUserWallets = (userId) =>
    apiClient.get(`/admin/users/${userId}/wallets`).then((r) => r.data);

export const getUserTransactions = (userId, params = {}) =>
    apiClient.get(`/admin/users/${userId}/transactions${buildQueryString(params)}`).then((r) => r.data);

// ── Wallet Transactions ────────────────────────────────────────────
export const getWalletTransactions = (walletId, params = {}) =>
    apiClient.get(`/admin/wallets/${walletId}/transactions${buildQueryString(params)}`).then((r) => r.data);

// ── Limits ─────────────────────────────────────────────────────────
export const getLimits = () =>
    apiClient.get('/admin/limits').then((r) => r.data);

export const setLimits = (data) =>
    apiClient.put('/admin/limits', data).then((r) => r.data);

// ── Reward Credit ──────────────────────────────────────────────────
export const creditReward = (data) =>
    apiClient.post('/admin/reward/credit', data).then((r) => r.data);

// ── Closeout ───────────────────────────────────────────────────────
export const closeoutWallet = (data) =>
    apiClient.post('/admin/closeout', data).then((r) => r.data);

// ── Payouts ────────────────────────────────────────────────────────
export const getPayouts = (params = {}) =>
    apiClient.get(`/admin/payouts${buildQueryString(params)}`).then((r) => r.data);

export const approvePayout = (payoutId) =>
    apiClient.patch(`/admin/payouts/${payoutId}/approve`).then((r) => r.data);

export const processPayout = (payoutId, data) =>
    apiClient.patch(`/admin/payouts/${payoutId}/process`, data).then((r) => r.data);

// ── Settlements ────────────────────────────────────────────────────
export const generateSettlement = (data) =>
    apiClient.post('/admin/settlements/generate', data).then((r) => r.data);

export const getSettlements = (params = {}) =>
    apiClient.get(`/admin/settlements${buildQueryString(params)}`).then((r) => r.data);

export const confirmSettlement = (settlementId) =>
    apiClient.patch(`/admin/settlements/${settlementId}/confirm`).then((r) => r.data);

// ── Revenue Report ─────────────────────────────────────────────────
export const getRevenueReport = (params = {}) =>
    apiClient.get(`/admin/revenue-report${buildQueryString(params)}`).then((r) => r.data);

// ── Holds ───────────────────────────────────────────────────────────
export const getHolds = (params = {}) =>
    apiClient.get(`/admin/holds${buildQueryString(params)}`).then((r) => r.data);

export const createHold = (data) =>
    apiClient.post('/admin/holds', data).then((r) => r.data);

export const captureHold = (data) =>
    apiClient.post('/admin/holds/capture', data).then((r) => r.data);

export const releaseHold = (data) =>
    apiClient.post('/admin/holds/release', data).then((r) => r.data);

export const getHold = (holdId) =>
    apiClient.get(`/admin/holds/${holdId}`).then((r) => r.data);
